import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=fcb92c12&scoped=true&"
import script from "./ModalUser.vue?vue&type=script&lang=js&"
export * from "./ModalUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalUser.vue?vue&type=style&index=0&id=fcb92c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb92c12",
  null
  
)

export default component.exports